'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UniversalSidebarPreviewFooter from 'customer-data-sidebar/universal/UniversalSidebarPreviewFooter';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { COMMERCE_PAYMENT_TYPE_ID, MEETING_EVENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalSidebarPanelCardsWrapper = ({
  children,
  label,
  objectTypeId,
  objectId,
  onClose,
  readOnly
}) => {
  const getPanelHeaderText = () => {
    switch (objectTypeId) {
      case COMMERCE_PAYMENT_TYPE_ID:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataSidebar.universalSidebarPanelCardsWrapper.paymentsHeader"
        });
      case MEETING_EVENT_TYPE_ID:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataSidebar.universalSidebarPanelCardsWrapper.meetingsHeader"
        });
      default:
        return label;
    }
  };
  const renderHeader = () => {
    return /*#__PURE__*/_jsx(PanelHeader, {
      "data-selenium-test": "preview-panel-header",
      "data-test-id": "preview-panel-header",
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: getPanelHeaderText()
        })
      })
    });
  };
  const renderFooter = () => {
    const saveBarContainerProps = {
      alwaysShowSaveBar: true
    };
    return /*#__PURE__*/_jsx(UniversalSidebarPreviewFooter, Object.assign({
      objectTypeId: objectTypeId,
      objectId: objectId,
      readOnly: readOnly
    }, saveBarContainerProps));
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose,
      "data-selenium-test": "sidebar-preview-panel--close-button",
      "data-test-id": "sidebar-close-button"
    }), renderHeader(), /*#__PURE__*/_jsx(PanelBody, {
      "data-selenium-test": "preview-panel-body",
      children: children
    }), renderFooter()]
  });
};
UniversalSidebarPanelCardsWrapper.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node.isRequired,
  objectTypeId: PropTypes.string.isRequired,
  objectId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
export default UniversalSidebarPanelCardsWrapper;